export default __webpack_public_path__ + "static/media/videoWebm.c14e08d5.webm";